import { authRoles } from '../../../auth/authRoles'
import { lazy } from 'react'

const RecetaRegistroApp = lazy(() => import('./view/RecetasRegistro'))
const RecetasActualizarApp = lazy(() => import('./view/RecetasActualizar'))
const RecetaGestion = lazy(() => import('./view/RecetasGestion'))

export const recetasRoutesMap = {
  gestion: {
    path: '/recetas/gestion',
    name: 'Recetas',
    action: 'RECETAS',
  },
  registro: {
    path: '/recetas/registro',
    name: 'Nueva receta',
    action: 'ADMINISTRAR_RECETAS',
  },
  actualizar: {
    path: '/recetas/actualizar/:id',
    name: 'Actualizar receta',
    action: 'ADMINISTRAR_RECETAS',
  },
}

const recetasRoutes = [
  {
    path: recetasRoutesMap.gestion.path,
    element: <RecetaGestion />,
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.registro.path,
    element: <RecetaRegistroApp />,
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.actualizar.path,
    element: <RecetasActualizarApp />,
    auth: authRoles.admin,
  },
]
export default recetasRoutes
